import React, { useState, useEffect, useCallback } from "react";
import * as S from "./ModalConsultorStyle";
import styled from "styled-components";
import Loading from "../../Loader";
import { FaSearch } from "react-icons/fa";
import adminAxiosInstance from "../../../Services/api/adminAxiosInstance";
import { useMessage } from "../../../Context/MessageContext";
import {consultorService} from "../../../Services/consultorService"
import { FaTrash } from "react-icons/fa";

const SearchContainer = styled.div`
  display: flex;
  margin-bottom: 20px;
  input {
    flex-grow: 1;
    height: 45px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    background: rgba(0, 0, 0, 0.3);
    padding: 0 20px;
    color: #fff;
    border-radius: 6px 0 0 6px;
    &:focus {
      outline: none;
      border-color: #e6aa3a;
    }
  }
  button {
    width: 60px;
    border: none;
    background: #e6aa3a;
    color: #111;
    cursor: pointer;
    border-radius: 0 6px 6px 0;
    font-size: 18px;
  }
`;

const ListContainer = styled.div`
  max-height: 400px;
  overflow-y: auto;
`;

const ListItem = styled.div`
  display: grid;
  grid-template-columns: 1fr 3fr 3fr;
  padding: 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  cursor: pointer;
  transition: background-color 0.3s;
  color: #fff;
  &:hover {
    background-color: rgba(230, 170, 58, 0.1);
  }
`;

export default function ModalConsultor({ onClose, client, setClient }) {
  const [search, setSearch] = useState("");
  const [consultores, setConsultores] = useState([]);
  const [load, setLoad] = useState(false);
  const { showMessage } = useMessage();

  const getConsultores = useCallback(async () => {
    setLoad(true);
    const isNumeric = /^\d+$/.test(search.replace(/[^\d]/g, ""));
    const name = !isNumeric ? search : "";
    const cpfCnpj = isNumeric ? search : "";
    try {
      const res = await consultorService.searchConsultores(name, cpfCnpj);
      setConsultores(res);
    } catch (err) {
      showMessage("Erro ao obter consultores", "error");
      console.error(err);
    } finally {
      setLoad(false);
    }
  }, [search, showMessage]);

  useEffect(() => {
    getConsultores();
  }, [getConsultores]);

  const handleSearch = (e) => {
    if (e.key === "Enter") getConsultores();
  };

  const handleAssociate = async (consultor) => {
    if (!window.confirm(`Associar ${consultor.name} ao cliente ${client.name}?`)) return;
    
    await updateAssociation(consultor.id, consultor.name);
  };
  
  // --- NOVA FUNÇÃO PARA DESASSOCIAR ---
  const handleRemoveAssociation = async () => {
    if (!window.confirm(`Tem certeza que deseja remover o consultor do cliente ${client.name}?`)) return;

    await updateAssociation(null, null); // Envia null para remover
  };

  // Função centralizada para atualizar a associação
  const updateAssociation = async (consultantId, consultantName) => {
    setLoad(true);
    const patchOperations = [
      { fieldName: "consultorId", fieldNewValue: consultantId },
    ];
    try {
      // O endpoint by-token no backend de Contratos de Minérios já cuida de tudo
      await adminAxiosInstance.patch(`client/by-token`, patchOperations, {
        headers: { "X-Client-ID": client.id },
      });
      
      setClient((prevClient) => ({
        ...prevClient,
        consultorId: consultantId,
        consultorName: consultantName,
      }));

      showMessage(consultantId ? "Consultor associado com sucesso!" : "Consultor removido com sucesso!", "success");
      onClose(true);
    } catch (error) {
      showMessage(`Erro: ${error.response?.data?.message || error.message}`, "error");
    } finally {
      setLoad(false);
    }
  }

  return (
    <S.ModalOverlay>
      <S.ModalContainer size="large">
        <Loading load={load} />
        <S.ModalHeader>
          <h3>Associar / Alterar Consultor</h3>
          <S.CloseButton onClick={() => onClose(false)}>&times;</S.CloseButton>
        </S.ModalHeader>
        <S.ModalBody>
          <S.CurrentConsultant>
            <span>Consultor Atual: <strong>{client.consultorName || "Nenhum"}</strong></span>
            {client.consultorId && (
              <S.RemoveButton onClick={handleRemoveAssociation}>
                <FaTrash /> Remover
              </S.RemoveButton>
            )}
          </S.CurrentConsultant>
          <SearchContainer>
            <input
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onKeyPress={handleSearch}
              placeholder="Pesquise por nome ou CPF/CNPJ"
            />
            <button onClick={getConsultores}><FaSearch /></button>
          </SearchContainer>
          <ListContainer>
            <ListItem style={{ fontWeight: "bold", borderBottom: "2px solid #E6AA3A" }}>
              <span>ID</span>
              <span>Nome</span>
              <span>Email</span>
            </ListItem>
            {consultores?.length > 0 ? (
              consultores.map((c) => (
                <ListItem key={c.id} onClick={() => handleAssociate(c)}>
                  <span>{c.id}</span>
                  <span>{c.name}</span>
                  <span>{c.email}</span>
                </ListItem>
              ))
            ) : (
              <div style={{ padding: "20px", textAlign: "center", color: "#fff" }}>
                Nenhum consultor encontrado.
              </div>
            )}
          </ListContainer>
        </S.ModalBody>
      </S.ModalContainer>
    </S.ModalOverlay>
  );
}